import { Fragment } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { Error } from '../Error';
import { Label } from '../Label';

import styles from './styles.module.scss';

const Input = ({
  errorMessage,
  label,
  labelClassName,
  inputClassName,
  name,
  ...props
}) => (
  <Fragment>
    <Label value={label} className={labelClassName}>
      <div className={styles.container}>
        <Field
          {...props}
          className={cc([styles.input, inputClassName])}
          name={name}
        />
      </div>
    </Label>
    <Error name={name} value={errorMessage} />
  </Fragment>
);

Input.propTypes = {
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
};

Input.displayName = 'Input';

export { Input };
